import { styled } from '@styles/theme'

export const styleModalFreeLimit = {
	Title: styled('h2', {
		color: '$neutral120',
		textAlign: 'center',
		fontSize: '20px',
		fontStyle: 'normal',
		_font: 'medium',
		fontWeight: 500,
		lineHeight: '146%',
		maxWidth: '323px',
		margin: 'auto',
	}),

	Info: styled('h5', {
		_font: 'normal',
		color: '$neutral120',
		textAlign: 'center',
		fontSize: '18px',
		fontStyle: 'normal',
		fontWeight: '400',
		lineHeight: '138%',
		letterSpacing: '0.9px',
		marginTop: '20px',
	}),

	ButtonsContainer: styled('div', {
		display: 'flex',
		gap: '21px',
		marginTop: '32px',
		flexDirection: 'column',

		'@sm': {
			flexDirection: 'row',
		},
	}),
}
